import { FC } from 'react';

import { useBreakpoint } from '@contexts/breakpoints';
import Skeleton from '@components/skeletons/Skeleton';
import { Row } from '@components/formStyles';

import {
  SkeletonItemHeader,
  SkeletonItemMain,
  SkeletonItemWrapper,
  SkeletonItemInfo,
  SkeletonItemDivider,
  MobileSkeletonItemWrapper,
  MobileSkeletonItemContent,
} from './styled';

const TourCardSkeleton: FC = () => {
  const { xl } = useBreakpoint();
  return (
    <>
      {xl ? (
        <SkeletonItemWrapper>
          <Skeleton width={244} height={313} />

          <SkeletonItemMain>
            <SkeletonItemInfo>
              <Skeleton
                width={320}
                height={18}
                borderRadius={2}
                marginBottom={10}
              />
            </SkeletonItemInfo>
            <SkeletonItemHeader>
              <Skeleton
                width={140}
                height={18}
                borderRadius={2}
                marginBottom={10}
                marginRight={10}
              />

              <Skeleton
                width={140}
                height={18}
                borderRadius={2}
                marginBottom={10}
                marginRight={10}
              />

              <Skeleton
                width={140}
                height={18}
                borderRadius={2}
                marginBottom={10}
                marginRight={10}
              />
            </SkeletonItemHeader>

            <SkeletonItemDivider />
          </SkeletonItemMain>
        </SkeletonItemWrapper>
      ) : (
        <MobileSkeletonItemWrapper>
          <Skeleton height={200} marginBottom={15} />
          <Skeleton marginLeft={12} width={110} height={18} borderRadius={4} />
          <SkeletonItemHeader style={{ marginTop: 8, padding: 12 }}>
            <Skeleton width={50} height={12} borderRadius={2} />

            <Skeleton width={60} height={12} borderRadius={2} />

            <Skeleton width={50} height={12} borderRadius={2} />
          </SkeletonItemHeader>
          <Row justifyContent='space-between'>
            <MobileSkeletonItemContent>
              <Skeleton
                width={110}
                height={18}
                marginBottom={10}
                borderRadius={4}
              />
              <Skeleton
                width={120}
                height={18}
                marginBottom={10}
                borderRadius={4}
              />
              <Skeleton
                width={115}
                height={18}
                marginBottom={10}
                borderRadius={4}
              />
            </MobileSkeletonItemContent>
          </Row>
        </MobileSkeletonItemWrapper>
      )}
    </>
  );
};

export default TourCardSkeleton;
